import Cookies from "js-cookie";
import { authenticationType, b2cAccessToken, b2cRefreshToken, dateOfBirth, internalAccessToken, internalRefreshToken, isFetchingStorage, legacyUserId, loginName, name, sidebarCollapsed, surname, userId, userRoles, } from "../Utils/LocalStorageNames";
import { authenticationTypeCookieLifetime, b2cAccessTokenCookieLifetime, b2cRefreshTokenCookieLifetime, dateOfBirthCookieLifetime, internalAccessTokenCookieLifetime, internalRefreshTokenCookieLifetime, legacyUserIdCookieLifetime, loginNameCookieLifetime, nameCookieLifetime, sidebarCollapsedCookieLifetime, surnameCookieLifetime, userIdCookieLifetime, userRolesCookieLifetime, } from "../Utils/CookiesLifetime";
export var getB2CaccessToken = function () {
    var currentToken = Cookies.get(b2cAccessToken);
    return currentToken;
};
export var getB2CrefreshToken = function () {
    var token = Cookies.get(b2cRefreshToken);
    return token;
};
export var getInternalAccessToken = function () {
    var currentToken = Cookies.get(internalAccessToken);
    return currentToken;
};
export var getInternalRefreshToken = function () {
    var token = Cookies.get(internalRefreshToken);
    return token;
};
export var getLegacyUserId = function () {
    var token = Cookies.get(legacyUserId);
    return token;
};
export var getUserId = function () {
    var token = Cookies.get(userId);
    return token;
};
export var getDateOfBirth = function () {
    var token = Cookies.get(dateOfBirth);
    return token;
};
export var getLoginName = function () {
    var token = Cookies.get(loginName);
    return token;
};
export var getName = function () {
    var token = Cookies.get(name);
    return token;
};
export var getSurname = function () {
    var token = Cookies.get(surname);
    return token;
};
export var getUserRoles = function () {
    var roles = JSON.parse(Cookies.get(userRoles) || "[]");
    return roles;
};
export var getAuthenticationType = function () {
    var token = Cookies.get(authenticationType);
    return token;
};
export var getSidebarCollapsed = function () {
    var token = Cookies.get(sidebarCollapsed);
    return token;
};
export var setB2CaccessToken = function (newValue) {
    Cookies.set(b2cAccessToken, newValue, {
        expires: b2cAccessTokenCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setB2CrefreshToken = function (newValue) {
    Cookies.set(b2cRefreshToken, newValue, {
        expires: b2cRefreshTokenCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setInternalAccessToken = function (newValue) {
    Cookies.set(internalAccessToken, newValue, {
        expires: internalAccessTokenCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setInternalRefreshToken = function (newValue) {
    Cookies.set(internalRefreshToken, newValue, {
        expires: internalRefreshTokenCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setUserId = function (newValue) {
    Cookies.set(userId, newValue, {
        expires: userIdCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setLegacyUserId = function (newValue) {
    Cookies.set(legacyUserId, newValue, {
        expires: legacyUserIdCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setDateOfBirth = function (newValue) {
    Cookies.set(dateOfBirth, newValue, {
        expires: dateOfBirthCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setLoginName = function (newValue) {
    Cookies.set(loginName, newValue, {
        expires: loginNameCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setName = function (newValue) {
    Cookies.set(name, newValue, {
        expires: nameCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setSurname = function (newValue) {
    Cookies.set(surname, newValue, {
        expires: surnameCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setUserRoles = function (newValue) {
    Cookies.set(userRoles, newValue, {
        expires: userRolesCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setAuthenticationType = function (newValue) {
    Cookies.set(authenticationType, newValue, {
        expires: authenticationTypeCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var setSidebarCollapsed = function (newValue) {
    Cookies.set(sidebarCollapsed, newValue, {
        expires: sidebarCollapsedCookieLifetime,
        path: "/",
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearAllValuesFromStorages = function () {
    clearAllValuesFromStoragesExceptLegacyUserId();
    clearLegacyUserId();
};
export var clearAllValuesFromStoragesExceptLegacyUserId = function () {
    clearAllTokensFromStorages();
    clearUserId();
    clearDateOfBirth();
    clearLoginName();
    clearName();
    clearSurname();
    clearUserRoles();
    clearAuthenticationType();
    clearIsFetching();
    clearSidebarCollapsed();
};
export var clearAllTokensFromStorages = function () {
    clearB2CAccessToken();
    clearB2CRefreshToken();
    clearInternalAccessToken();
    clearInternalRefreshToken();
};
export var clearB2CAccessToken = function () {
    Cookies.remove(b2cAccessToken, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearB2CRefreshToken = function () {
    Cookies.remove(b2cRefreshToken, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearInternalAccessToken = function () {
    Cookies.remove(internalAccessToken, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearInternalRefreshToken = function () {
    Cookies.remove(internalRefreshToken, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearLegacyUserId = function () {
    Cookies.remove(legacyUserId, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearUserId = function () {
    Cookies.remove(userId, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearDateOfBirth = function () {
    Cookies.remove(dateOfBirth, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearLoginName = function () {
    Cookies.remove(loginName, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearName = function () {
    Cookies.remove(name, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearSurname = function () {
    Cookies.remove(surname, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearUserRoles = function () {
    Cookies.remove(userRoles, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearAuthenticationType = function () {
    Cookies.remove(authenticationType, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearIsFetching = function () {
    Cookies.remove(isFetchingStorage, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
export var clearSidebarCollapsed = function () {
    Cookies.remove(sidebarCollapsed, {
        domain: process.env.REACT_APP_COOKIES_URL,
    });
};
